// @ts-strict-ignore
import queryString from 'query-string';
import React, { useCallback, useEffect, useState } from 'react';
import { batch, connect } from 'react-redux';
// @ts-expect-error ts-migrate(2305) FIXME: Module '"react-router"' has no exported member 'Co... Remove this comment to see the full error message
import { ContextRouter, withRouter } from 'react-router';

import { CurrentUser } from 'api/currentUser';
import { SearchSection } from 'api/types/shared.types';
import SearchInputs from 'components/Search/SearchInputs';
import {
  State as MainSearch,
  clearSearchLocation as clearSearchLocationAction,
  initializeLandingPageSearch as initializeLandingPageSearchAction,
  initializeSearch as initializeSearchAction,
  setPageIndex as setPageIndexAction,
  setSearchFilter as setSearchFilterAction,
  setSearchQuery as setSearchQueryAction,
  setUserInitiatedSearch as setUserInitiatedSearchAction,
  updateSearchLocation as updateSearchLocationAction,
} from 'store/main/ducks/mainSearch';
import { showModal as showModalAction } from 'store/main/ducks/modal';
import { trackClicked } from 'utils/analytics';
import { DisplayedType, listingTypesBySection } from 'utils/constants';
import { stringify } from 'utils/functional';
import { listingSearchHome } from 'utils/searchHomePages';
import { truncateToUTF8Bytes } from 'utils/string';
import { getFirstParam } from 'utils/url';

type InitialProps = {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSearch?: (arg0: Record<string, any>) => void;
  searchSection: SearchSection;
  inPageHeader?: boolean;
  searchFrom?: string;
  defaultSearchType?: string;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/no-unused-prop-types
  isStaff?: boolean;
  searchMode?: boolean;
};
type OwnProps = InitialProps & ContextRouter;
type Props = OwnProps & {
  searchSection: SearchSection;
  type: ListingType;
  query: string;
  currentUser: CurrentUser;
  mainSearch: MainSearch | null | undefined;
  setUserInitiatedSearch: () => unknown;
  setPageIndex: (arg0: number, arg1: boolean) => unknown;
  setSearchQuery: (arg0: string, arg1: boolean) => unknown;
  setSearchFilter: (arg0: string, arg1: unknown) => unknown;
  updateSearchLocation: (
    arg0: SearchLocation,
    arg1: boolean
  ) => Promise<unknown>;
  clearSearchLocation: (arg0: boolean) => Promise<unknown>;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/no-unused-prop-types, @typescript-eslint/no-explicit-any
  initializeLandingPageSearch: (...args: Array<any>) => any;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/no-unused-prop-types, @typescript-eslint/no-explicit-any
  initializeSearch: (...args: Array<any>) => any;
  defaultSearchType: ListingType | null | undefined;
  searchMode: boolean;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  showModal: (...args: Array<any>) => any;
};

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const SearchInputsContainer = (props: Props) => {
  const { searchSection } = props;
  const [listingTypes] = useState<Array<DisplayedType>>(
    listingTypesBySection[searchSection]
  );
  const [type, setType] = useState<ListingType>(
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    props.type || props.defaultSearchType || listingTypes[0]
  );
  const [query, setQuery] = useState(
    truncateToUTF8Bytes(
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      props.query || getFirstParam(props.location, 'q') || '',
      512
    )
  );
  const [enqueueSearch, setEnqueueSearch] = useState([false, null]);
  const [location, setLocation] = useState<SearchLocation | null | undefined>(
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    props.mainSearch.searchLocation
  );
  useEffect(
    () => {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      if (props.defaultSearchType) {
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/destructuring-assignment
        setType(props.defaultSearchType);
      }
    }, // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    [props.defaultSearchType]
  );
  useEffect(
    () => {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      setLocation(props.mainSearch.searchLocation);
    }, // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    [props.mainSearch.searchLocation]
  );
  const setListingType = setType;
  const setUserQuery = useCallback(
    (q: string) => {
      // Algolia has a max query length of 512 bytes
      setQuery(truncateToUTF8Bytes(q, 512));
    },
    [setQuery]
  );

  const setSearchLocation = (
    searchLocation: SearchLocation | null | undefined,
    shouldEnqueueSearch = true,
    setRemote = false
  ) => {
    setLocation(searchLocation);

    if (setRemote) {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      props.setSearchFilter('locationTypeFacet', [
        'REMOTE',
        'REMOTE_TEMPORARY',
      ]);
    }

    if (shouldEnqueueSearch) {
      // @ts-expect-error ts-migrate(2322) FIXME: Type 'string' is not assignable to type 'boolean'.
      setEnqueueSearch([true, query]);
    }
  };

  const search = useCallback(
    (stateQuery) => {
      const {
        clearSearchLocation,
        updateSearchLocation,
        setUserInitiatedSearch,
        history,
        searchFrom,
        searchMode,
        setSearchFilter,
        setSearchQuery,
      } = props;
      const stateSearchLocation = location;
      const stateType = type;

      const finalQuery = stateQuery;

      batch(() => {
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/destructuring-assignment
        const mainSearchLocationAddress = props.mainSearch.searchLocation
          ? // TODO: Fix this the next time the file is edited.
            // eslint-disable-next-line react/destructuring-assignment
            props.mainSearch.searchLocation.latLongAddress
          : undefined;

        const stateSearchLocationAddress = stateSearchLocation
          ? // @ts-expect-error fix me
            stateSearchLocation.latLongAddress
          : undefined;

        const locationsMatch =
          mainSearchLocationAddress === stateSearchLocationAddress;

        if (!locationsMatch) {
          if (stateSearchLocation) {
            updateSearchLocation(stateSearchLocation, true).then(() =>
              // TODO: Fix this the next time the file is edited.
              // eslint-disable-next-line react/destructuring-assignment
              props.setPageIndex(0, false)
            );
          } else {
            // TODO: Fix this the next time the file is edited.
            // eslint-disable-next-line react/destructuring-assignment
            clearSearchLocation(true).then(() => props.setPageIndex(0, false));
          }
        }

        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/destructuring-assignment
        if (props.type && stateType !== props.type) {
          setSearchFilter('type', stateType);

          if (stateType === 'VOLOP') {
            setSearchFilter('actionTypeFacet', ['VOLOP']);
          }
        }

        setSearchQuery(stateQuery, true);
      });

      const searchHome = listingSearchHome(stateType);

      if (searchHome && !searchMode) {
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/destructuring-assignment
        if (finalQuery && finalQuery === props.query) {
          history.replace(`${searchHome}?q=${encodeURIComponent(finalQuery)}`, {
            searchFrom,
          });
        } else {
          history.push(`${searchHome}?q=${encodeURIComponent(finalQuery)}`, {
            searchFrom,
          });
        }

        setUserInitiatedSearch();
      }
    },
    [props, location, type]
  );
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/destructuring-assignment
  const redirectTo = props.location
    ? // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      `${props.location.pathname}${props.location.search}`
    : '';

  const clickLogin = (e: React.SyntheticEvent) => {
    e.preventDefault();
    trackClicked('Log In Search Hero');
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    props.showModal('LOGIN', {
      redirectTo,
    });
  };

  const clickSignup = (e: React.SyntheticEvent) => {
    e.preventDefault();
    trackClicked('Sign Up Search Hero');
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    props.showModal('SIGNUP', {
      redirectTo,
    });
  };

  const redirectParam = queryString.stringify({
    to: redirectTo,
  });
  useEffect(() => {
    const [enqueued, searchQuery] = enqueueSearch;

    if (enqueued) {
      setEnqueueSearch([false, null]);
      search(stringify(searchQuery));
    }
  }, [enqueueSearch, props, search]);
  const clearSearchInput = useCallback(
    () => {
      setUserQuery('');

      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      if (props.searchMode) {
        search('');
      }
    }, // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    [setUserQuery, search, props.searchMode]
  );
  const selectedType =
    listingTypes.find((l) => l === type) ||
    (listingTypes.includes('JOB') ? 'JOB' : listingTypes[0]);
  return (
    <SearchInputs
      listingTypes={listingTypes}
      selectedType={selectedType}
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      onSearch={props.onSearch}
      query={query}
      searchLocation={location}
      setListingType={setListingType}
      setQuery={setUserQuery}
      clearSearchInput={clearSearchInput}
      redirectParam={redirectParam}
      setSearchLocation={setSearchLocation}
      search={search}
      placeholder={getText('Search by keyword, skill, or interest')}
      xsPlaceholder={getText('Keyword, skill, or interest')}
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      inPageHeader={props.inPageHeader}
      clickLogin={clickLogin}
      clickSignup={clickSignup}
      // @ts-expect-error ts-migrate(2322) FIXME: Type 'boolean' is not assignable to type '(...args... Remove this comment to see the full error message
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      showLogin={props.currentUser.isLoaded && !props.currentUser.id}
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/destructuring-assignment
      currentUserLoaded={props.currentUser.isLoaded}
    />
  );
};

const mapStateToProps = ({ mainSearch, currentUser }) => ({
  mainSearch,
  query: mainSearch ? mainSearch.query : '',
  searchMode: mainSearch ? mainSearch.searchMode : false,
  type: mainSearch && mainSearch.filters && mainSearch.filters.type,
  currentUser,
});

// @ts-expect-error ts-migrate(2558) FIXME: Expected 2 type arguments, but got 1.
// eslint-disable-next-line import/no-default-export
export default withRouter<InitialProps>(
  // @ts-expect-error ts-migrate(2558) FIXME: Expected 5 type arguments, but got 6.
  connect<Props, OwnProps, _, _, _, _>( // $FlowFixMe: for some reason, react-redux flow definition fails if we include the react-router Location type
    mapStateToProps, // TODO: Figure out below, will solve most of our FlowFixMe statements
    // $FlowFixMe: for some reason, react-redux flow definition fails if we include the react-router Location type
    {
      setUserInitiatedSearch: setUserInitiatedSearchAction,
      setSearchFilter: setSearchFilterAction,
      setPageIndex: setPageIndexAction,
      setSearchQuery: setSearchQueryAction,
      updateSearchLocation: updateSearchLocationAction,
      clearSearchLocation: clearSearchLocationAction,
      initializeSearch: initializeSearchAction,
      initializeLandingPageSearch: initializeLandingPageSearchAction,
      showModal: showModalAction,
    }
  )(SearchInputsContainer)
);
